import React, { useState } from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';
import { ExpandableCard, Flexbox } from '@ibinder/common-frontend';
import { GET_ALL_TENDER_USERS_QUERY } from 'Shared/api/queries/getTenderParticipants.query';
import { impersonateTenderUser } from '../AdminActionBar/index';
import ImpersonateUserModal from '../AdminActionBar/ImpersonateUserModal';
import { ThemeButton } from '@ibinder/ui-common-core';

const UserList = styled.ul`
  padding: 0;
`;

const UserObj = styled(Flexbox)`
  width: 100%;
  padding: 0.5rem;
  overflow-x: auto;
`;

const Information = styled.p`
  font-size: ${({ theme }) => theme.fontStyles.mediumFont.fontSize}px;
  color: ${({ theme }) => theme.colors.discrete50};
`;

const TenderData = ({ tender, organizationId, type }) => {
  const [selectedParticipant, setSelectedParticipant] = useState(null);

  localStorage.setItem('tenantId', organizationId);

  const participants = useQuery(GET_ALL_TENDER_USERS_QUERY, {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    context: {
      headers: {
        orgid: organizationId
      }
    },
    variables: {
      tenderId: tender.id
    }
  });

  if (participants.loading) {
    return <p>Loading please wait..</p>;
  }

  if (
    !participants.data ||
    !participants.data?.get ||
    participants.data?.get?.length === 0
  ) {
    return null;
  }
  const participantList = participants?.data?.get.filter(
    (participant) => participant !== null
  );
  return (
    <>
      {selectedParticipant && (
        <ImpersonateUserModal
          targetUserId={selectedParticipant.user.id}
          userName={selectedParticipant.user.fullName}
          onClose={() => setSelectedParticipant(null)}
          onImpersonated={(token) =>
            impersonateTenderUser(
              token,
              selectedParticipant.user.fullName,
              selectedParticipant.user.email,
              selectedParticipant.user.userId,
              tender,
              organizationId,
              selectedParticipant.bidId
            )
          }
        />
      )}
      <Information>Tender name: {tender.name}</Information>
      <UserList>
        {participantList.map((item) => {
          return (
            <ExpandableCard
              key={item.user.id}
              expanded={false}
              headerInfo={
                <UserObj
                  alignItems="center"
                  flexDirection={'row'}
                  justifyContent={'space-between'}
                  key={item.user.id}
                >
                  <p>
                    {item.bidId
                      ? `${item.user.fullName} - Bid: ${item.bidId}`
                      : `${item.user.fullName}`}
                  </p>
                </UserObj>
              }
            >
              <ul>
                <li>UserId: {item.user.id}</li>
                <li>Fullname: {item.user.fullName}</li>
                <li>Last update: {item.user.lastUpdated}</li>
                <li>Role: {item.userRole}</li>
                <ThemeButton
                  buttonType="default"
                  onClick={() => setSelectedParticipant(item)}
                >
                  Impersonate
                </ThemeButton>
              </ul>
            </ExpandableCard>
          );
        })}
      </UserList>
    </>
  );
};

export default TenderData;
